import { render, staticRenderFns } from "./LessonTest.vue?vue&type=template&id=8a5c7a1c&scoped=true&"
import script from "./LessonTest.vue?vue&type=script&lang=js&"
export * from "./LessonTest.vue?vue&type=script&lang=js&"
import style0 from "./LessonTest.vue?vue&type=style&index=0&id=8a5c7a1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a5c7a1c",
  null
  
)

export default component.exports